import React from 'react'
import Container from '../components/Container'
import Title from '../components/Title'

import AboutImage from '../assets/images/aboutUsLocks.png'
import Box from '../components/Box'
import { ReactComponent as FastServices } from '../assets/svg/aboutUs/fastServices.svg'
import { ReactComponent as Professional } from '../assets/svg/aboutUs/professional.svg'
import { ReactComponent as Fair } from '../assets/svg/aboutUs/fair.svg'


const Data = [
    {
        "title": "Reliable and Fast Service",
        "description": "When you need us most, our team responds quickly to emergencies and delivers efficient solutions.",
        image: <FastServices className='h-[50px] w-[50px] md:w-[80px] md:h-[80px]' />,

    },
    {
        "title": "Experienced Professionals",
        "description": "Whether it's a simple lock repair or a complex security upgrade, we handle it with precision and care.",
        image: <Professional className='h-[50px] w-[50px] md:w-[80px] md:h-[80px]' />

    },
    {
        "title": "Transparent and Fair Pricing",
        "description": "When you need us most, our team responds quickly to emergencies and delivers efficient solutions.",
        image: <Fair className='h-[50px] w-[50px] md:w-[80px] md:h-[80px]' />,

    }
]

function AboutUs() {
    return (
        <Container>
            <div className='flex flex-col gap-5'>
                <Title className='text-center !text-black'>
                    Why Choose Us ?
                </Title>
                <div className='text-center text-base md:text-xl'>
                    At Schliesserk, we understand that security and reliability are non-negotiable. That’s why we’re committed to providing top-tier locksmith services tailored to your needs. From swift emergency responses to expert installations, we prioritize your safety, convenience, and peace of mind every step of the way.
                </div>
                <div className='mt-5 flex flex-col lg:flex-row gap-8 items-center'>
                    <div className="lg:basis-[55%]">
                        <div className="flex flex-col gap-5">
                            {Data.map((item, index) => (
                                <Box className='flex gap-4' key={index}>
                                    <div className='flex-none'>

                                        {item.image}
                                    </div>
                                    <div>
                                        <p className='md:text-2xl font-bold mb-2'>{item.title}</p>
                                        <span className='text-sm md:text-xl text-[#666666]'>{item.description}</span>
                                    </div>
                                </Box>
                            ))}

                        </div>
                    </div>
                    <div className="lg:basis-[45%]">
                        <img src={AboutImage} className='w-full h-auto' alt="" />
                    </div>
                </div>
            </div>
        </Container>
    )
}

export default AboutUs